module.exports = __webpack_public_path__ + "allegro.svg?9af9d0d3d81e39bce9447aaaf8d33ac2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/allegro.svg
// module id = 39
// module chunks = 2